export default "__VITE_ASSET__CJll0Hdy__"